import React from 'react';
import ExcelJS from 'exceljs';
import {saveAs} from 'file-saver';
import {MyTeamUser} from '../../types/TypesPage';
import GreenButton from '../Buttons/GreenButton';
import {useTranslation} from 'react-i18next';

interface Props {
	data: MyTeamUser[];
}

export const ExcelExportButton: React.FC<Props> = ({data}) => {
	const {t} = useTranslation();

	const handleExport = async () => {
		const workbook = new ExcelJS.Workbook();
		const sheet = workbook.addWorksheet('Дані');
		// Заголовки з твоїми замінами
		sheet.columns = [
			{header: 'Лінія', key: 'line', width: 5},
			{header: 'Прізвище Ім\'я', key: 'fullName', width: 25},
			{header: 'Контракт', key: 'idNumber', width: 15},
			{header: 'Дата народження', key: 'dob', width: 15},
			{header: 'Тип', key: 'type', width: 10},
			{header: 'Квал', key: 'qual', width: 15},
			{header: 'Наставник', key: 'parent', width: 25},
			{header: 'о/о', key: 'oo', width: 10},
			{header: 'к/о', key: 'ko', width: 12},
		];
		// Додання рядків
		data.forEach((item) => {
			sheet.addRow({
				line: item.level,
				fullName: item.name,
				idNumber: item.contract,
				dob: item.registration_date,
				type: formatType(item.status),
				oo: formatOO(+item.active_points),
				ko: formatKO(+item.active_points_tree),
				qual: item.qlfc, // картинка вставиться пізніше
				parent: item.parent_name || '',
			});
		});

		// Форматування чисел
		sheet.getColumn('ko').numFmt = '#,##0';
		sheet.getColumn('oo').numFmt = '0.0';

		// Завантаження файлу
		const buf = await workbook.xlsx.writeBuffer();
		saveAs(new Blob([buf]), 'report.xlsx');
	};

	return (
		<GreenButton text={t('Імпорт')} type={'button'} onClick={handleExport} />
	);
};

// Логіка Типу
const formatType = (status: string) => {
	if (status === 'optima') return 'К';
	if (['loyalty', 'business', 'manager', 'lider'].includes(status)) return 'БП';
	return '';
};

const formatKO = (val: number | null) => (val != null ? Math.round(val) : '');

const formatOO = (val: number | null) =>
	val != null ? Number(val).toFixed(1) : '';
